import React from 'react'
import ReactDOM from 'react-dom'
import {Route, IndexRoute, Router, hashHistory} from 'react-router'
import App from './components/App'
import Dashboard from './components/dashboard/dashboard.jsx'
import Schedule from './components/schedule/schedule'
import HistoryView from './components/history/history'
import Account from './components/account/account.jsx'
import Billing from './components/billing/billing.jsx'
import Invoice from './components/billing/invoice.jsx'
import Support from './components/support/support'
import InfoPage from './components/account/info-page'
import ReactGA from 'react-ga'
import {fetchLoginData} from './components/api'

ReactGA.plugin.require('ec')
function logPageView() {
  ReactGA.set({ page: window.location.pathname })
  ReactGA.pageview(window.location.hash)
}

function highPropertyCountRedirect() {
  document.cookie="optOutOfBeta=true; Path=/; Expires=Wed, 01 Jan 2020 00:00:00 GMT"
  window.location.assign(window.location.origin + '/customer/showCustomerDashboard')
}

fetchLoginData().then((data) => {
    if (data.error) {
        let error = data.error.response
        if (error.status === 412) { // 412 Precondition doesn't exist (Client Login)
            // For now, we redirect to Old consumer dashboard
            highPropertyCountRedirect();
        } else if (error.status === 403) {
	        let origin = window.location.origin
	        let formattedUrl = window.location.toString()
	        formattedUrl = formattedUrl.replace(origin, '')
	        formattedUrl = formattedUrl.replace(/[/]/g, '%2F')

	        document.cookie = "PLAY_FLASH=;  Path=/; Expires=Thu, 01 Jan 1970 00:00:00 GMT"
	        document.cookie='PLAY_FLASH="url=' + formattedUrl + '"; Path=/;'
	        window.location.assign(window.location.origin + '/login')
        }
    } else {
	    if (data.response) {
	    	let response = data.response
            if (!window.sessionStorage.getItem("keycloakToken")) {
                let keycloakToken = response.customer.keycloakToken;
                if (keycloakToken && keycloakToken.accessToken) {
                    window.sessionStorage.setItem("keycloakToken", JSON.stringify(response.customer.keycloakToken));
                    if (!localStorage.getItem("te_dashboard")) {
                        localStorage.setItem('te_dashboard', JSON.stringify({
                            token: keycloakToken.accessToken,
                            refreshToken: keycloakToken.refreshToken,
                            expiryTime: keycloakToken.expiryTime,
                            refreshExpiryTime: keycloakToken.refreshExpiryTime,
                            language: 'english',
                        }));
                    }
                }
            }
		    if(response.customer.addresses.length >= 10) {
			    highPropertyCountRedirect()
		    } else {
		      let customerName = data.response.customer.name;
		      if (customerName.trim().includes(' ')){
		        response.customer.firstName = customerName.substr(0, customerName.indexOf(' '));
		        response.customer.lastName = customerName.substr(customerName.indexOf(' ') + 1);
          }
			    let routes = (
                    <Route name='app' displayName='Home' path='/' component={App} loginData={response}>
                        <IndexRoute component={Dashboard} />
                        <Route name='dashboard' path='dashboard' component={Dashboard} />
                        <Route name='schedule' path='schedule' component={Schedule} />
                        <Route name='history' path='history' component={HistoryView} />
                        <Route name='account' path='account' component={Account} />
                        <Route name='billing' path='billing' component={Billing} />
                        <Route name='invoice' path="invoice/:invoiceId" component={Invoice} />
                        <Route name='support' path='support' component={Support} />
                        <Route name='updateUserInfo' path='updateUserInfo' component={InfoPage} />
                    </Route>
			    )

			    ReactDOM.render(<Router history={hashHistory} routes={routes} onUpdate={logPageView}/>, document.getElementById('root'))
		    }
	    }
    }
})



// WEBPACK FOOTER //
// ./src/index.js